import { render, staticRenderFns } from "./InputFile2.vue?vue&type=template&id=3d1217d0&"
import script from "./InputFile2.vue?vue&type=script&lang=ts&"
export * from "./InputFile2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports